import React from 'react';
import { Text, TextProps } from '@mantine/core';
import { H1SemiBold as H1SemiBoldStyle } from 'theme/typography';

interface H1SemiBoldProps extends TextProps {
  customStyle?: React.CSSProperties;
  children: React.ReactNode; // Explicitly define the children prop
}

/**
 * Applies the H1SemiBold typography style.
 */
const H1SemiBold: React.FC<H1SemiBoldProps> = ({ children, customStyle, ...restProps }) => {
  return (
    <Text {...restProps} style={{ ...H1SemiBoldStyle, ...customStyle }}>
      {children}
    </Text>
  );
};

export default H1SemiBold;
